import type { Theme } from '../styles/theme.js';
import { STRINGS } from '../strings.js';

/**
 * Pièce jointe en cours de composition, côté widget uniquement. `localUrl`
 * est un blob: local (aperçu immédiat, avant même la fin du téléversement) ;
 * `id` n'existe qu'une fois le serveur ayant accusé réception.
 */
export type PendingAttachment = {
  key: string;
  localUrl: string;
  status: 'uploading' | 'ready' | 'error';
  id?: string;
  /** URL signée renvoyée par le serveur — sert d'aperçu optimiste à l'envoi. */
  url?: string;
  error?: string;
};

type Props = {
  items: PendingAttachment[];
  onRemove: (key: string) => void;
  theme: Theme;
};

export function AttachmentPreview({ items, onRemove, theme }: Props) {
  if (items.length === 0) return null;
  return (
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', padding: '8px 16px 0' }}>
      {items.map((item) => (
        <div
          key={item.key}
          style={{ position: 'relative', width: '56px', height: '56px', flex: '0 0 auto' }}
        >
          <img
            src={item.localUrl}
            alt=""
            style={{
              width: '56px',
              height: '56px',
              objectFit: 'cover',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              opacity: item.status === 'ready' ? 1 : 0.5,
              display: 'block',
            }}
          />
          {item.status === 'uploading' && (
            <span
              style={{
                position: 'absolute',
                inset: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10px',
                color: '#fff',
                backgroundColor: 'rgba(0,0,0,0.45)',
                borderRadius: '8px',
              }}
            >
              {STRINGS.attachUploading}
            </span>
          )}
          {item.status === 'error' && (
            <span
              style={{
                position: 'absolute',
                inset: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px',
                color: '#fff',
                backgroundColor: 'rgba(180,30,30,0.6)',
                borderRadius: '8px',
              }}
              aria-hidden="true"
            >
              !
            </span>
          )}
          <button
            type="button"
            aria-label={STRINGS.attachRemove}
            onClick={() => onRemove(item.key)}
            style={{
              position: 'absolute',
              top: '-6px',
              right: '-6px',
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              border: 'none',
              backgroundColor: theme.textColor,
              color: '#fff',
              fontSize: '13px',
              lineHeight: '20px',
              padding: '0',
              cursor: 'pointer',
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
